import { PageSection } from '@patternfly/react-core'
import * as React from 'react'
import { useCallback, useEffect, useState } from 'react'

import { useListPrograms } from '@app/domain/program/program.hooks'

import { ProgramListComponent } from '../admin/programs/program_list_component'

const INITIAL_PAGE_NUMBER = 1
const INITIAL_RECORDS_PER_PAGE = 50

export const ClinicProgramList = () => {
  const [pageNumber, setPageNumber] = useState(INITIAL_PAGE_NUMBER)
  const [recordsPerPage, setRecordsPerPage] = useState(INITIAL_RECORDS_PER_PAGE)

  const { programs, totalNumberOfRecords, getPrograms } = useListPrograms()

  const onPerPageSelect = useCallback((recordsPerPage) => {
    setPageNumber(1)
    setRecordsPerPage(recordsPerPage)
  }, [])

  const onSetPage = useCallback((updatedPageNumber) => {
    setPageNumber(updatedPageNumber)
  }, [])

  const refreshAll = useCallback(() => {
    getPrograms(pageNumber, recordsPerPage)
  }, [getPrograms, pageNumber, recordsPerPage])

  useEffect(() => {
    refreshAll()
  }, [refreshAll])

  return (
    <>
      <PageSection className="pf-m-light">
        <ProgramListComponent
          programs={programs}
          pagination={{
            pageNumber,
            totalNumberOfRecords,
            recordsPerPage,
            onSetPage,
            onPerPageSelect,
          }}
          getProgramLink={(programId) => `/clinic/program-summary/${programId}`}
        />
      </PageSection>
    </>
  )
}
